<template>
  <v-app>
    <!-- Topbar — מכיל כפתור המבורגר + כותרת -->
    <v-app-bar app flat color="white" style="border-bottom: 1px solid #e5e7eb;" elevation="0">
      <v-btn icon @click="toggleDrawer">
        <v-icon color="#0e81c4">mdi-menu</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <span style="color: #34a5e6; font-size: 18px; font-weight: 600;">מערכת ניהול - חלוקת מוצרי חלב</span>
      <v-spacer></v-spacer>
    </v-app-bar>

    <!-- Sidebar -->
    <TablesList ref="sidebar" @showTable="showTable" @showAccountDetails="showAccountDetails()"
      :tableListArray="tableListArray" />

    <!-- Main Content -->
    <div class="main-content">
      <router-view :userDetails="userDetailsForEdit" @Edit="editUserDetails" @Cancle="showAccountDetails" />
    </div>
  </v-app>
</template>

<script>
import TablesList from '@/components/TablesList'
import Auth from '@/services/auth.service.js'

export default {
  name: 'home',
  components: { TablesList },
  data: () => ({
    userDetailsForEdit: {},
    tableListArray: [
      { name: "דאשבורד" },
      { name: "משתמשים" },
      { name: "לקוחות" },
      { name: "מלאי" },
      { name: "הזמנות" },
      { name: "דוחות" }
    ],
  }),
  methods: {
    toggleDrawer() {
      const sidebar = this.$refs.sidebar;
      if (sidebar) {
        if (sidebar.isMobile) {
          sidebar.drawer = !sidebar.drawer;
        } else {
          sidebar.collapsed = !sidebar.collapsed;
        }
      }
    },
    showTable(name) {
      const routeMap = {
        'דאשבורד': 'dashboard',
        'משתמשים': 'users',
        'לקוחות': 'customers',
        'מלאי': 'products',
        'הזמנות': 'orders',
        'דוחות': 'reports',
      };
      const routeName = routeMap[name];
      if (routeName && this.$route.name !== routeName) {
        this.$router.push({ name: routeName });
      }
    },
    showAccountDetails() {
      if (this.$route.name !== 'account') {
        this.$router.push({ name: 'account' });
      }
    },
    editUserDetails(user) {
      this.userDetailsForEdit = user;
      if (this.$route.name !== 'account-edit') {
        this.$router.push({ name: 'account-edit' });
      }
    },
  },
  created() {
    const auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: 'login' });
      return;
    }

    if (this.$route.name === 'home') {
      const role = Auth.getUserRole();
      if (role === 'admin') {
        this.$router.replace({ name: 'users' });
      } else if (role === 'user') {
        this.tableListArray = this.tableListArray.filter(t => t.name !== 'משתמשים');
        this.$router.replace({ name: 'customers' });
      }
    }

    const role = Auth.getUserRole();
    if (role === 'user') {
      this.tableListArray = this.tableListArray.filter(t => t.name !== 'משתמשים');
    }
  },
}
</script>

<style scoped>
.main-content {
  padding: 16px;
  direction: rtl;
}
</style>